export type Trend = 'new' | 'none' | 'low volume' | 'active' | 'declining' | 'steady';

export function trend(cur: number, prev: number): Trend {
  if (prev === 0 && cur > 0) return 'new';
  if (prev === 0) return 'none';
  if (prev < 10) return 'low volume'; // noise floor — 4→3 is -25% and means nothing
  const delta = (cur - prev) / prev;
  if (delta >= 0.15) return 'active';
  if (delta <= -0.15) return 'declining';
  return 'steady';
}
